export default __webpack_public_path__ + "static/media/central_andes_2_18.2942021b.JPG";